module.exports = __webpack_public_path__ + "static/media/ic_hs_main_benefits.97cd6072.svg";